var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary btn-lg my-3",on:{"click":_vm.renew}},[_vm._v("つぎの もんだいへ")])}
var staticRenderFns = []

export { render, staticRenderFns }